
import React from 'react';

/**
 * Componente de Estado de Carregamento para Contatos - OTIMIZADO
 * 
 * Exibe skeletons detalhados enquanto os dados dos contatos estão sendo carregados.
 * Simula fielmente a estrutura da tabela de contatos para melhor UX.
 * 
 * MELHORIAS:
 * - Skeleton mais detalhado e realista
 * - Animação de pulse suave
 * - Estrutura que corresponde à tabela real
 * - Filtros e barra de busca incluídos
 */

export const ContactsLoadingState = () => {
  return (
    <div className="space-y-6 animate-pulse">
      {/* Header skeleton */}
      <div className="flex items-center justify-between">
        <div className="space-y-2">
          <div className="h-8 bg-gray-200 rounded w-32" />
          <div className="h-4 bg-gray-100 rounded w-48" />
        </div>
        <div className="h-10 bg-green-200 rounded-xl w-40" />
      </div>

      {/* Filtros e busca skeleton */}
      <div className="bg-white rounded-2xl border border-gray-200 p-4 space-y-4">
        <div className="flex items-center gap-3">
          {/* Busca */}
          <div className="flex-1 h-10 bg-gray-100 rounded-xl" />
          {/* Botão de filtros */}
          <div className="h-10 w-32 bg-gray-100 rounded-xl" />
          {/* Botão de exportar */}
          <div className="h-10 w-28 bg-gray-100 rounded-xl" />
        </div>
      </div>

      {/* Tabela skeleton */}
      <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden">
        {/* Header da tabela */}
        <div className="border-b border-gray-200 bg-gray-50 p-4">
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-1 h-4 bg-gray-200 rounded w-4" />
            <div className="col-span-3 h-4 bg-gray-200 rounded w-20" />
            <div className="col-span-2 h-4 bg-gray-200 rounded w-16" />
            <div className="col-span-2 h-4 bg-gray-200 rounded w-16" />
            <div className="col-span-2 h-4 bg-gray-200 rounded w-20" />
            <div className="col-span-2 h-4 bg-gray-200 rounded w-16" />
          </div>
        </div>

        {/* Linhas da tabela */}
        <div className="divide-y divide-gray-100">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="p-4">
              <div className="grid grid-cols-12 gap-4 items-center">
                {/* Checkbox */}
                <div className="col-span-1">
                  <div className="h-4 w-4 bg-gray-200 rounded" />
                </div>

                {/* Nome e avatar */}
                <div className="col-span-3 flex items-center gap-3">
                  <div className="h-10 w-10 bg-gray-200 rounded-full flex-shrink-0" />
                  <div className="space-y-2 flex-1">
                    <div className="h-4 bg-gray-200 rounded w-32" />
                    <div className="h-3 bg-gray-100 rounded w-24" />
                  </div>
                </div>

                {/* Telefone */}
                <div className="col-span-2">
                  <div className="h-4 bg-gray-100 rounded w-28" />
                </div>

                {/* Email */}
                <div className="col-span-2">
                  <div className="h-4 bg-gray-100 rounded w-36" />
                </div>

                {/* Etapa */}
                <div className="col-span-2">
                  <div className="h-6 bg-gray-100 rounded-full w-24" />
                </div>

                {/* Ações */}
                <div className="col-span-2 flex gap-2 justify-end">
                  <div className="h-8 w-8 bg-gray-100 rounded" />
                  <div className="h-8 w-8 bg-gray-100 rounded" />
                  <div className="h-8 w-8 bg-gray-100 rounded" />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Footer da tabela */}
        <div className="border-t border-gray-200 bg-gray-50 p-4">
          <div className="flex items-center justify-between">
            <div className="h-4 bg-gray-200 rounded w-48" />
            <div className="flex gap-2">
              <div className="h-8 w-8 bg-gray-200 rounded" />
              <div className="h-8 w-8 bg-gray-200 rounded" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
